<template>
  <div class="page-wrap">
    <Header></Header>
    <div class="content flex-r-center">
      <div class="card-width">
        <el-card v-loading="loading">
          <div slot="header" class="card-wrap flex-center-center fz24">
            申领个人电子私章
          </div>
          <div class="order-area">
            <!--            <div class="choose-area">-->
            <!--              <div class="common-title">套餐选择</div>-->
            <!--              <div class="choose-list">-->
            <!--                <div-->
            <!--                    class="choose-item"-->
            <!--                    @click="choosePackage(item, index)"-->
            <!--                    v-for="(item, index) in packagesData"-->
            <!--                    :key="index"-->
            <!--                    :class="index == activeIndex ? 'choose-item-active' : ''"-->
            <!--                >-->
            <!--                  <div class="recommend" v-if="item.recommend">推荐</div>-->
            <!--                  <div class="cost-wrap"-->
            <!--                       :class="index == activeIndex ? 'cost-wrap-active' : ''">-->
            <!--                    ￥<span class="cost">{{ item.productPrice }}</span>-->
            <!--                    &lt;!&ndash; <span v-if="item.year">/{{ item.year }}</span> &ndash;&gt;-->
            <!--                  </div>-->
            <!--                  <div class="desc">{{ item.productName }}</div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="order-detail">
              <div class="common-title">订单明细</div>
              <div class="flex-center-between mb10">
                <div class="order-name ml10">
                  个人私章 {{ chosenData.productName }}套餐
                </div>
                <div class="order-price">￥{{ chosenData.productPrice }}</div>
              </div>
              <div class="order-desc fz16 ml10">{{ chosenData.productName }}</div>
            </div>
            <div class="price-detail">
              <div class="common-title">价格明细</div>
              <div class="price-detail-list fz16">
                商品总价(共1枚电子印章) ：{{ chosenData.productPrice }}元/枚*1枚
                <span class="total-price">
                  合计
                  <span style="color: #ff4742">{{ chosenData.productPrice }}元</span>
                </span>
              </div>
            </div>
            <div class="button-area">
              <!--              <el-button class="button-cancel" @click="handlePay('wxpay')">微信支付</el-button>-->
              <!--              <el-button type="primary" class="button-pay" @click="handlePay('alipay')">支付宝支付</el-button>-->
              <el-button class="button-cancel" @click="handlePay('wxpay')" v-if="chosenData.productPrice == 0">
                确认制作
              </el-button>
              <el-button class="button-cancel" @click="handlePay('wxpay')" v-if="chosenData.productPrice != 0">
                微信支付
              </el-button>
              <el-button type="primary" class="button-pay" @click="handlePay('alipay')"
                         v-if="chosenData.productPrice != 0">
                支付宝支付
              </el-button>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <pay-dialog ref="payRef"></pay-dialog>
    <Bottom></Bottom>
  </div>
</template>
<script>
import Bottom from "@/components/Bottom.vue";
import Header from "@/components/Header.vue";
import PayDialog from "./components/PayDialog.vue";
import Cookies from "js-cookie";

export default {
  components: {Bottom, Header, PayDialog},
  data() {
    return {
      activeIndex: 0,
      packagesData: [],
      chosenData: {},
      userId: null,
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.account.user
    },
    isLogin() {
      return this.user && this.user.userId
    }
  },
  mounted() {
    this.userId = this.$auth.getUserId() || this.user.userId
    this.loadData();
  },
  methods: {
    loadData() {
      let params = {
        productType: "personal",
        type: 'user',
        userId: this.userId
      };
      this.$http.post(this.$api.register.getProductsInfo, params).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.length > 0) {
            this.packagesData = res.data.data;
            if (this.packagesData.length) {
              this.chosenData = this.packagesData[0];
            }
          } else {
            this.$message.error('暂无商品信息')
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    choosePackage(item, index) {
      this.activeIndex = index;
      this.chosenData = item;
    },
    handlePay(type) {
      this.createOrder(type);
    },
    createOrder(payType) {
      if (this.loading) return
      this.loading = true;

      let seal = JSON.parse(Cookies.get('seal'))
      // Cookies.remove('seal')

      let params = {
        payType: payType,
        userId: this.userId,
        productId: this.chosenData.productId,
        buyCount: 1,
        sealTypes: ['99'],
        sealName: seal.sealName,
        sealWidth: seal.sealWidth,
        sealHeight: seal.sealHeight,
      }

      this.$http.post(this.$api.register.createOrder, params).then(res => {
        this.loading = false;
        if (res.data.code == 200 && res.data.data.tradeNo) {
          if (res.data.data.payStatus == '0') {
            let codeImg = "data:image/png;base64," + res.data.data.buyQrcode;
            let payChannel = payType === 'wxpay' ? '微信' : '支付宝';
            this.$refs.payRef.show(codeImg, payChannel, res.data.data.tradeNo, this.chosenData.productPrice);
          } else {
            // this.$router.push({path: "/userCenter/myPrivateSeal"});
            let params = {
              tradeNo: res.data.data.tradeNo
            };
            this.$http.post(this.$api.register.doTrackTrade, params, {
              "Content-Type": "multipart/form-data"
            }).then(res => {
              if (res.data.code == 200) {
                // setTimeout(() => {
                this.loading = false;
                this.$message.success('操作成功')
                this.$router.push({path: "/userCenter/myPrivateSeal"});
                // }, 5000)
              } else {
                this.loading = false;
                // 剩余制作次数不足，剩余制作次数：0
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              this.$message.error(err.msg)
              this.$router.push({path: "/userCenter/myPrivateSeal"});
            });
          }
        } else {
          this.$message.error(res.data.msg || '支付创建失败');
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.page-wrap {
  .content {
    width: 100%;
    padding: 20px 30px;
    background: #f5f7fa;
    min-height: calc(100vh - 104px);
    padding-bottom: 60px;

    .common-title {
      display: inline-block;
      width: 100%;
      margin: 10px 0;
      padding-left: 14px;
      position: relative;
      font-size: 18px;
      text-align: left;

      &:after {
        content: "";
        position: absolute;
        width: 4px;
        height: 18px;
        background: linear-gradient(0deg, #0d90ff, #00a1ff);
        left: 0;
        bottom: 50%;
        transform: translateY(50%);
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }

    .order-area {
      margin-left: 112px !important;
      margin-right: 112px !important;

      .choose-list {
        display: flex;
        margin: 20px 0;
        align-items: center;
        justify-content: left;
        flex-wrap: wrap;

        .choose-item {
          display: inline-block;
          width: 200px;
          height: 130px;
          margin-right: 20px;
          margin-bottom: 20px;
          border-radius: 7px;
          border: 2px solid #e4c8a2;
          text-align: center;
          box-sizing: border-box;
          background: linear-gradient(0deg, #fdf7ec, #fefefe);
          position: relative;
          cursor: pointer;

          .recommend {
            position: absolute;
            z-index: 3;
            width: 66px;
            height: 24px;
            line-height: 24px;
            left: 0;
            top: -12px;
            color: #fff;
            font-size: 14px;
            border-radius: 14px 0 14px 0;
            background: linear-gradient(270deg, #ff9303, #fe622c);
          }

          .cost-wrap {
            padding: 30px 0 0;
            text-align: center;
            color: #e95d49;
            font-size: 18px;

            .cost {
              font-size: 39px;
              font-weight: bolder;
            }
          }

          .desc {
            text-align: center;
            color: #795021;
            font-size: 17px;
          }

          .cost-wrap-active {
            color: #795021;
          }
        }

        .choose-item-active {
          background: url("~@/assets/login/image-chosen.png") no-repeat;
          background-size: 100% 100%;
          border-color: transparent;
        }
      }
    }

    .order-detail {
      .order-name {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: bold;
      }

      .order-price {
        color: #ff4742;
        font-size: 20px;
      }

      .order-desc {
        display: flex;
        color: #666;
        border-bottom: 1px solid #eee;
        padding: 10px 0 10px 3px;
      }
    }

    .price-detail-list {
      padding: 6px 5px 6px 9px;
      text-align: left;
      border-bottom: 1px solid #eee;

      .total-price {
        margin-left: 50px;
      }
    }

    .button-area {
      margin-top: 55px;

      .button-cancel {
        width: 200px !important;
        margin-right: 50px !important;
        border: 1px solid #407fff;
        font-size: 16px !important;
        color: #407fff;
      }

      .button-pay {
        width: 200px !important;
        margin-left: 10px;
        box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
        font-size: 16px !important;
      }
    }
  }
}

::v-deep .el-card {
  width: 1200px;
  min-height: 730px;
}
</style>
